(function () {
    'use strict';
    class IdentityService {
        constructor(EXTERNAL_NAME, ENV, ACCOUNTS_APP_URL) {
            this.EXTERNAL_NAME = EXTERNAL_NAME;
            this.ENV = ENV;
            this.ACCOUNTS_APP_URL = ACCOUNTS_APP_URL;
            let AuthenticationErrorCodes = window[this.EXTERNAL_NAME].AuthenticationErrorCodes,
                AuthenticationClient = window[this.EXTERNAL_NAME].AuthenticationClient,
                Environments = window[this.EXTERNAL_NAME].Environments,
                Initializer = window[this.EXTERNAL_NAME].Initializer;

            AuthenticationClient.onError(function (errorCode) {
                if(errorCode === AuthenticationErrorCodes.NOT_SIGNED_IN || errorCode === AuthenticationErrorCodes.MISSING_OR_MALFORMED_COOKIE) {
                    // redirect to login
                    window.location.href = this.ACCOUNTS_APP_URL + '/logout';
                    console.error('Failed to Auth ' + errorCode);
                } else {
                    // just log it?
                    console.error('Failed to Auth ' + errorCode);
                }
            });

            if (this.ENV === 'production') {
              Initializer.initialize(Environments.PRODUCTION);
            } else if ( this.ENV !== 'production'){
              Initializer.initialize(Environments.STAGING);
            }
        }
    }

    angular
        .module('MW.Influencers.IdentityService', [])
        .service('IdentityService', [
            'EXTERNAL_NAME',
            'ENV',
            'ACCOUNTS_APP_URL',
            IdentityService
        ]);
})();